export default __webpack_public_path__ + "img/25.f97241fb.jpg";